<template>
  <div>
    <datatable
      title="Company Meetings"
      @delete="deleteMeeting"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'company-meetings',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'timing',
          value: 'timing',
          is_time: true
        },
        {
          name: 'history_company',
          value: 'history_company.name'
        },
        {
          name: 'applicant_message',
          value: 'applicant_message'
        },
        {
          name: 'company_message',
          value: 'company_message'
        },
        {
          name: 'requested_interview_preparation',
          value: 'requested_interview_preparation'
        }
      ],
      data: [],
      operations: [],
      chosen_meeting: {},
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceMeetings({
          current_type: 'Company',
          current_resource_id: this.company_id
        })
        .then(response => {
          this.data = response
        })
    },
    deleteMeeting (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deleteMeeting',
        method_params: { id: delete_data.id, current_type: 'Company', current_resource_id: this.company_id }
      })
    },
    editClick (data) {
      this.chosen_meeting = data
    }
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
